import React, { useState,useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../ExamPaperPrepration/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';
import axios from 'axios';

function CreateExamPaperPreparation() {
    const [ExamPreparationTitle, setExamPreparationTitle] = useState("");
    const [titleOptions, setTitleOptions] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState("");
    const [ExamPreparationDescription, setExamPreparationDescription] = useState("");
    const [ExamPreparationLobo, setExamPreparationLobo] = useState(null);
    const [status, setStatus] = useState("");
        const [roleList, setRoleList] = useState([]);
    
        useEffect(() => {
            fetchRoles();
        }, []);
    
        const fetchRoles = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/getExamPreparations`, {
                    headers: {
                        "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                        "Content-Type": "application/json",
                    },
                });
                console.log("dhghfghfgf",response)
                setRoleList(response.data);
            } catch (err) {
                console.error("Error fetching Exam Preparations:", err);
            }
        };
    

    const navigate = useNavigate();

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setExamPreparationLobo(e.target.files[0]);
        }
    };

    const handleTitleSave = () => {
        if (ExamPreparationTitle && !titleOptions.includes(ExamPreparationTitle)) {
            setTitleOptions([...titleOptions, ExamPreparationTitle]);
            setSelectedTitle(ExamPreparationTitle);
            setExamPreparationTitle("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("title", selectedTitle);
        formData.append("description", ExamPreparationDescription);
        formData.append("status", status);
        if (ExamPreparationLobo) {
            formData.append("media_image_name", ExamPreparationLobo);
        }

        const headers = {
            "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`
        };

        try {
            const response = await fetch(`${API_BASE_URL}/createExamPreparationsPaper/null`, {
                method: "POST",
                headers,
                body: formData,
                redirect: "follow"
            });

            const result = await response.text();

            if (response.ok) {
                console.log("Success:", result);
                navigate("/admin/examPaperPreparationist");
            } else {
                console.error("Error:", result);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Create Exam Preparation Paper</h1>
                        </div>
                        <div className="report-body">
                            <div className="user-form">
                                <form onSubmit={handleSubmit} encType="multipart/form-data">

                                    {/* Title input and Save */}
                                    {/* <div className="mb-3 d-flex align-items-center">
                                        <input
                                            type="text"
                                            className="form-control me-2"
                                            placeholder="Enter Title"
                                            value={ExamPreparationTitle}
                                            onChange={(e) => setExamPreparationTitle(e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            style={{ padding: "4px 16px", fontSize: "14px", lineHeight: "1", whiteSpace: "nowrap", height: "auto" }}
                                            onClick={handleTitleSave}
                                        >
                                            Save
                                        </button>

                                    </div> */}

                                    <h4 className="mt-4 mb-3">Exam Preparation Paper</h4>

                                    {/* Dropdown */}
                                    <div className="mb-3">
                                        <label className="form-label">Select Title</label>
                                        <select
                                            className="form-control"
                                            value={selectedTitle}
                                            onChange={(e) => setSelectedTitle(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Title</option>
                                            {roleList.map((item, index) => (
                                                <option key={index} value={item.exam_title}>
                                                    {item.exam_title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Logo Upload */}
                                    <div className="mb-3">
                                        <label className="form-label">Logo (Upload Image)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            required
                                        />
                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <ReactQuill
                                            theme="snow"
                                            value={ExamPreparationDescription}
                                            onChange={setExamPreparationDescription}
                                            style={{ height: "200px", marginBottom: "50px" }}
                                        />
                                    </div>

                                    {/* Status Dropdown */}
                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    {/* Final Create Button */}
                                    <button type="submit" className="btn btn-primary">
                                        CREATE
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateExamPaperPreparation;
